function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isTextSelection, isNodeSelection, posToDOMRect, Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import tippy from 'tippy.js';

var BubbleMenuView = /*#__PURE__*/function () {
  function BubbleMenuView(_ref) {
    var _this = this;

    var editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        _ref$tippyOptions = _ref.tippyOptions,
        tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
        _ref$updateDelay = _ref.updateDelay,
        updateDelay = _ref$updateDelay === void 0 ? 250 : _ref$updateDelay,
        shouldShow = _ref.shouldShow;

    _classCallCheck(this, BubbleMenuView);

    this.preventHide = false;

    this.shouldShow = function (_ref2) {
      var view = _ref2.view,
          state = _ref2.state,
          from = _ref2.from,
          to = _ref2.to;
      var doc = state.doc,
          selection = state.selection;
      var empty = selection.empty; // Sometime check for `empty` is not enough.
      // Doubleclick an empty paragraph returns a node size of 2.
      // So we check also for an empty text size.

      var isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection); // When clicking on a element inside the bubble menu the editor "blur" event
      // is called and the bubble menu item is focussed. In this case we should
      // consider the menu as part of the editor and keep showing the menu

      var isChildOfMenu = _this.element.contains(document.activeElement);

      var hasEditorFocus = view.hasFocus() || isChildOfMenu;

      if (!hasEditorFocus || empty || isEmptyTextBlock || !_this.editor.isEditable) {
        return false;
      }

      return true;
    };

    this.mousedownHandler = function () {
      _this.preventHide = true;
    };

    this.dragstartHandler = function () {
      _this.hide();
    };

    this.focusHandler = function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    };

    this.blurHandler = function (_ref3) {
      var event = _ref3.event;

      var _a;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = _this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === _this.editor.view.dom) {
        return;
      }

      _this.hide();
    };

    this.tippyBlurHandler = function (event) {
      _this.blurHandler({
        event: event
      });
    };

    this.handleDebouncedUpdate = function (view, oldState) {
      var selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
      var docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));

      if (!selectionChanged && !docChanged) {
        return;
      }

      if (_this.updateDebounceTimer) {
        clearTimeout(_this.updateDebounceTimer);
      }

      _this.updateDebounceTimer = window.setTimeout(function () {
        _this.updateHandler(view, selectionChanged, docChanged, oldState);
      }, _this.updateDelay);
    };

    this.updateHandler = function (view, selectionChanged, docChanged, oldState) {
      var _a, _b, _c;

      var state = view.state,
          composing = view.composing;
      var selection = state.selection;
      var isSame = !selectionChanged && !docChanged;

      if (composing || isSame) {
        return;
      }

      _this.createTooltip(); // support for CellSelections


      var ranges = selection.ranges;
      var from = Math.min.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$from.pos;
      })));
      var to = Math.max.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$to.pos;
      })));
      var shouldShow = (_a = _this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(_this, {
        editor: _this.editor,
        element: _this.element,
        view: view,
        state: state,
        oldState: oldState,
        from: from,
        to: to
      });

      if (!shouldShow) {
        _this.hide();

        return;
      }

      (_b = _this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
        getReferenceClientRect: ((_c = _this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || function () {
          if (isNodeSelection(state.selection)) {
            var node = view.nodeDOM(from);

            if (node) {
              var nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector('[data-node-view-wrapper]');

              if (nodeViewWrapper) {
                node = nodeViewWrapper.firstChild;
              }

              if (node) {
                return node.getBoundingClientRect();
              }
            }
          }

          return posToDOMRect(view, from, to);
        }
      });

      _this.show();
    };

    this.editor = editor;
    this.element = element;
    this.view = view;
    this.updateDelay = updateDelay;

    if (shouldShow) {
      this.shouldShow = shouldShow;
    }

    this.element.addEventListener('mousedown', this.mousedownHandler, {
      capture: true
    });
    this.view.dom.addEventListener('dragstart', this.dragstartHandler);
    this.editor.on('focus', this.focusHandler);
    this.editor.on('blur', this.blurHandler);
    this.tippyOptions = tippyOptions; // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = 'visible';
  }

  _createClass(BubbleMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy(editorElement, _objectSpread({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: 'manual',
        placement: 'top',
        hideOnClick: 'toggle'
      }, this.tippyOptions)); // maybe we have to hide tippy on its own blur event as well

      if (this.tippy.popper.firstChild) {
        this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
      }
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var state = view.state;
      var hasValidSelection = state.selection.from !== state.selection.to;

      if (this.updateDelay > 0 && hasValidSelection) {
        this.handleDebouncedUpdate(view, oldState);
        return;
      }

      var selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
      var docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
      this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
  }, {
    key: "show",
    value: function show() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a, _b;

      if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
        this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
      }

      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
      this.element.removeEventListener('mousedown', this.mousedownHandler, {
        capture: true
      });
      this.view.dom.removeEventListener('dragstart', this.dragstartHandler);
      this.editor.off('focus', this.focusHandler);
      this.editor.off('blur', this.blurHandler);
    }
  }]);

  return BubbleMenuView;
}();

var BubbleMenuPlugin = function BubbleMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new BubbleMenuView(_objectSpread({
        view: _view
      }, options));
    }
  });
};
/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */


var BubbleMenu = Extension.create({
  name: 'bubbleMenu',
  addOptions: function addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: 'bubbleMenu',
      updateDelay: undefined,
      shouldShow: null
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }

    return [BubbleMenuPlugin({
      pluginKey: this.options.pluginKey,
      editor: this.editor,
      element: this.options.element,
      tippyOptions: this.options.tippyOptions,
      updateDelay: this.options.updateDelay,
      shouldShow: this.options.shouldShow
    })];
  }
});
export { BubbleMenu, BubbleMenuPlugin, BubbleMenuView, BubbleMenu as default };